import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GoogleUser } from '../lib/cloudflare';

interface AuthState {
  user: GoogleUser | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  // Actions
  setUser: (user: GoogleUser | null) => void;
  setAuthState: (isAuthenticated: boolean, isLoading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, _get) => ({
      user: null,
      isAuthenticated: false,
      isLoading: true,

      setUser: (user) => set({ 
        user, 
        isAuthenticated: !!user,
        isLoading: false 
      }),

      setAuthState: (isAuthenticated, isLoading) => set({ isAuthenticated, isLoading }),

      clearAuth: () => set({ 
        user: null, 
        isAuthenticated: false,
        isLoading: false 
      }),
    }),
    {
      name: 'sparrow-auth', // localStorage 키 이름
      partialize: (state) => ({ 
        user: state.user,
        isAuthenticated: state.isAuthenticated 
      }),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.setAuthState(state.isAuthenticated, false);
        }
      },
    }
  )
); 